import { server } from 'config/environment'
import { makeAutoObservable } from 'mobx'
import { isMobile, isSafari } from 'util/mobile'

export class WindowUiStore {
  mobile = false
  safari = false
  width = 0
  height = 0
  scrollX = 0
  scrollY = 0

  constructor() {
    makeAutoObservable(this)
  }

  init(userAgent: string | undefined) {
    this.mobile = isMobile(userAgent)
    this.safari = isSafari(userAgent)
  }

  client() {
    if (server) return
    this.updateSize()
    this.updateScroll()
    window.addEventListener('resize', () => this.updateSize())
    window.addEventListener('scroll', () => this.updateScroll())
  }

  get small() {
    return this.width < 760
  }

  get tablet() {
    return this.width < 1024
  }

  private updateSize() {
    this.width = window.innerWidth
    this.height = window.innerHeight

    this.mobile = this.width < 760
  }

  private updateScroll() {
    this.scrollX = window.scrollX
    this.scrollY = window.scrollY
  }
}
